import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static values = {
    url: String,
    title: String,
  };

  connect() {
    this.handleScroll = this.handleScroll.bind(this);
    this.onTurboLoad = this.onTurboLoad.bind(this);

    window.addEventListener("scroll", this.handleScroll, { passive: true });
    document.addEventListener("turbo:load", this.onTurboLoad);

    // Check initial state
    this.handleScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("turbo:load", this.onTurboLoad);
  }

  onTurboLoad() {
    // Reset scroll state after page transition
    this.handleScroll();
  }

  handleScroll() {
    const scrollThreshold = 10;
    const isScrolled = window.scrollY > scrollThreshold;

    if (isScrolled) {
      this.element.classList.add("c-shop_header-shop-header--is-scrolled");
    } else {
      this.element.classList.remove("c-shop_header-shop-header--is-scrolled");
    }
  }

  share() {
    const shareData = {
      title: this.titleValue || "Schau dir das an!",
      url: this.urlValue || window.location.href,
    };

    if (navigator.share) {
      navigator.share(shareData).catch((err) => {
        if (err.name !== "AbortError") {
          this.fallbackShare();
        }
      });
    } else {
      this.fallbackShare();
    }
  }

  fallbackShare() {
    const url = this.urlValue || window.location.href;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        this.showNotification("Link in Zwischenablage kopiert!");
      })
      .catch(() => {
        // Silent fail
      });
  }

  showNotification(message) {
    // Create a simple toast notification
    const toast = document.createElement("div");
    toast.textContent = message;
    toast.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      z-index: 10000;
      font-size: 14px;
    `;

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 2000);
  }
}
